import _ from "lodash";

export const objectPropsToCamelCase = (obj) => {
	return _.mapKeys(obj, (value, key) => {
		return _.camelCase(key);
	});
};
